module.exports = __webpack_public_path__ + "img/makeping-bubble-logo-integrations-section.7930f09f.png";